import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import ReviewCard from "./ReviewCard";
import { ReviewDisplay } from "shared/types";

interface ReviewsListProps {
  reviews: ReviewDisplay[];
  sitterName: string;
}

const ReviewsList: React.FC<ReviewsListProps> = ({ reviews, sitterName }) => {
  const [displayCount, setDisplayCount] = useState(5);
  const REVIEWS_PER_PAGE = 5;

  const displayedReviews = reviews.slice(0, displayCount);
  const hasMore = displayCount < reviews.length;

  const handleLoadMore = () => {
    setDisplayCount((prev) => prev + REVIEWS_PER_PAGE);
  };

  if (!reviews || reviews.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: "white",
        borderRadius: 2,
        p: 3,
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      }}
    >
      {/* Header */}
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 3 }}>
        Reviews
      </Typography>

      {/* Reviews List */}
      <Box>
        {displayedReviews.map((review) => (
          <ReviewCard key={review.id} review={review} />
        ))}
      </Box>

      {/* Load More Button */}
      {hasMore && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Button
            onClick={handleLoadMore}
            variant="outlined"
            sx={{
              borderColor: "#178B8E",
              color: "#178B8E",
              textTransform: "none",
              px: 4,
              py: 1,
              borderRadius: 2,
              fontWeight: 600,
              "&:hover": {
                borderColor: "#0F6164",
                backgroundColor: "rgba(23, 139, 142, 0.04)",
              },
            }}
          >
            Load More Reviews ({reviews.length - displayCount} remaining)
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ReviewsList;
